module.exports = __webpack_public_path__ + "img/om_outer_ring.9f73469d.gif";